<script lang="ts" setup>
/**
 * @todo: Imho this component should be an UI-lib component.
 */

import { computed, ref, watch } from 'vue'
import { LIcon } from '@wgg.hyve/hyve-ui-library'

type Props = {
  label: string
  labelExpanded: string
  isOpen?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isOpen: false
})

const emit = defineEmits(['update:isOpen'])

const isExpanded = ref(props.isOpen)

async function toggle() {
  isExpanded.value = !isExpanded.value
  emit('update:isOpen', isExpanded.value)
}

const toggleLabel = computed(() => {
  return isExpanded.value ? props.labelExpanded : props.label
})

const toggleIcon = computed(() => {
  return isExpanded.value ? 'lnx-arrow_up' : 'lnx-arrow_down'
})

watch(
  () => props.isOpen,
  (newValue) => {
    isExpanded.value = newValue
  }
)
</script>

<template>
  <details ref="container" class="collapsible" @toggle="toggle">
    <summary class="collapsible__toggle-container">
      <span class="collapsible__title">{{ toggleLabel }}</span>
      <LIcon :icon="toggleIcon" class="collapsible__icon" />
    </summary>
    <slot></slot>
  </details>
</template>

<style lang="scss">
@import 'collapsible';
</style>
